import { useAppSelector } from "../../../hooks/hooks";
import {
  selectLanguage,
  selectTranslations,
} from "../../../shared/data-access/store/general/generalSlice";
import { checkTranslationKey } from "../../../utils/translation";
import "./streak-banner.scss";

export interface StreakBannerProps {
  days: number;
}

/**
 * FR-27: the flame-and-ribbon banner carrying the current count.
 *
 * `ribbon.svg` is the Figma ribbon frame exported whole, with the baked "12 DAYS" text path and
 * the export's backdrop rects removed - the count has to be dynamic, and everything else about the
 * artwork (the masked flame especially) survives better as one asset than as reassembled pieces.
 * The text below is positioned on the ribbon's own coordinates, so it lands where the design put it.
 */
export function StreakBanner({ days }: StreakBannerProps) {
  const translations = useAppSelector(selectTranslations);
  const lang = useAppSelector(selectLanguage);

  return (
    <div className="streak-banner">
      <img className="banner-art" src="/img/streak/ribbon.svg" alt="" />
      <div className="banner-count">
        {days} {checkTranslationKey(translations[lang]?.Days, "DAYS")}
      </div>
    </div>
  );
}
